import MicroModal from "micromodal";

export default function triggerPopUp() {
  const isPresent = document.querySelector(".notification-modal");
  if (!isPresent) {
    return;
  }

  function setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  }

  function getSessionStorage(key) {
    return sessionStorage.getItem(key);
  }

  function showModal() {
    const popup = document.querySelector(".notification-modal");
    const close = document.querySelector(".notification-modal-close");

    if (!popup.classList.contains("closed")) {
      MicroModal.show("notification-window");
    }

    document.onkeyup = function (event) {
      if (event.keyCode === 27) {
        MicroModal.close("notification-window");
        popup.classList.add("closed");
        setSessionStorage("notification_window_closed", "yes");
      }
    };

    close.addEventListener("click", function () {
      MicroModal.close("notification-window");
      popup.classList.add("closed");
      setSessionStorage("notification_window_closed", "yes");
      document.body.classList.add("notification-modal-closed");
    });
  }

  const modal = document.querySelector(".notification-modal");

  if (modal.classList.contains("cookie-activated")) {
    if (getSessionStorage("notification_window_closed") === "yes") {
      // don't show the popup
    } else {
      setTimeout(showModal, 600);
    }
  } else {
    function trigger() {
      MicroModal.show("notification-window");
    }
    setTimeout(trigger, 600);
  }
}
